module.exports = __webpack_public_path__ + "img/badge10.b8bf4c38.png";